<template>
    <!-- IE 2026 10 26 / ODOO-pending (заказ Игоря 26.10: меню процессной модели — форма меню с группировкой): кнопка модели в шапке открывает форму меню (MenuPanel —
         та же панель, что у меню пользователя / страницы: заголовок, строка чипсов поиска, колонки групп, Esc, Alt-объяснения) вместо плоского wj-menu.
         Группы — utils/pmMenuGroups.js: дерево «Process models» (модель → ветки What-if / снимки; колонки Title и Date from), «Scenarios», «Auto-recalculation»;
         футер «Open the full list» — прежний пункт «Choice PM in list». Чипсы поиска панели фильтруют и дерево (модель остаётся, если нашлась её ветка).
         Выбор — тот же пункт бэка, что слал wj-menu (menuNodeClicked → menuActionActiveDesk → executeStoreMethod). Выключатель fe.ux.pmMenuForm (AppTopbar) -->
    <MenuPanel ref="mp" :items="items" :title="t('Process model')" :titleIcon="'pi ' + titleIcon" :subtitle="subtitle" align="right" :caret="false"
        :hover="hoverMs > 0" :openDelay="hoverMs" :colWidth="340" :maxCols="2" :search="true" :searchPlaceholder="t('Search models and commands…')"
        :currentOf="currentOf" :footer="footer" help="pm" :helpVars="helpVars" :btnClass="btnClass" panelClass="pm-menu-panel"
        @pick="onPick" @footer="onFooter" @open="onOpen">
        <template #trigger><span class="pm-menu-title">{{ header }}</span></template>
    </MenuPanel>
</template>

<script>
import MenuPanel from '@/components/MenuPanel.vue'
import { useMainStore } from '@/stores/mainStore'
import { t, getLanguage } from '@/i18n'
import { pmMenu_groups, pmMenu_panelItems, pmMenu_recIcon } from '@/utils/pmMenuGroups'

// дата «2026-10-01» / «2026-10-20 07:44:01» → по языку интерфейса (uk / ru — 01.10.2026, en — 10/01/2026); нечитаемое — как есть
function fmtDate(s) {
    const v = String(s || '')
    const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(v)
    if (!m) return v
    try {
        const lang = getLanguage() || 'en'
        return new Intl.DateTimeFormat(lang === 'en' ? 'en-GB' : lang, { year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date(+m[1], +m[2] - 1, +m[3]))
    } catch (e) { return `${m[3]}.${m[2]}.${m[1]}` }
}

export default {
    name: 'PmMenuPanel',
    components: { MenuPanel },
    props: {
        header: { type: String, default: '' },          // текст кнопки — название открытой модели (AppTopbar.pmMenuHeader)
        btnClass: { type: [String, Array, Object], default: '' },
        hoverMs: { type: Number, default: 0 },          // пауза открытия по наведению (store.menuHoverOpenMs); 0 — только клик
    },
    setup() {
        const store = useMainStore()   // грабли 25.10: компонент шапки отдаёт store (callgraph-mixin читает this.store)
        return { store, t }
    },
    computed: {
        selectedId() { return String(this.store.process_model_record?.id || '') },
        groups() {
            const rec = this.store.process_model_record || {}
            const curId = String(this.store.process_model_current || '')
            // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: ежедневный архив ПМ): открыт архив — без пунктов записи (store.readonly_menu)
            return pmMenu_groups(this.store.readonly_menu(this.store.process_model_menu, 'model'), { currentId: curId, currentTitle: (rec.id && rec.id === curId) ? String(rec.title || '') : '' })   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: ежедневный архив ПМ): 'model' — меню модели (ревью #110599)
        },
        lastRun() {
            const v = this.store.process_model_record?.doc?.branch?.version || this.store.activeWORKSPACE?.record?.doc?.params?.version || ''
            const at = v ? (this.store._autoRecalcLast || {})[v] : ''
            return typeof at === 'string' ? at : ''
        },
        items() {
            void getLanguage()
            const rec = this.store.process_model_record || {}
            return pmMenu_panelItems(this.groups, {
                t, fmtDate, lastRun: this.lastRun,
                archiveSubmenu: this.archiveSubmenuOn,   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: ежедневный архив ПМ): архивы модели — папкой «Archive (N)» (выключатель fe.ux.pmArchiveSubmenu)
                // «Date from» открытой модели — из её записи (бэк в пункты меню дату пока не кладёт)
                dateFromOf: (n) => (rec.id && n.id === rec.id) ? String(rec.doc?.date_from || '') : '',
            })
        },
        archiveSubmenuOn() { void this.store._settingsEpoch; return this.store.setting('fe.ux.pmArchiveSubmenu', true) !== false },   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: ежедневный архив ПМ)
        subtitle() { return this.header },
        // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: ежедневный архив ПМ): значок заголовка формы — как у кнопки модели в шапке (архив — pi-history)
        titleIcon() { void this.store._settingsEpoch; return this.archiveSubmenuOn ? pmMenu_recIcon(this.store.process_model_record) : 'pi-sitemap' },
        footer() {
            return this.groups.list ? [{ id: 'list', label: t('Open the full list'), icon: 'pi pi-ellipsis-h', help: 'menuPanel.footer.pmList' }] : null
        },
        helpVars() {
            const cur = this.store.process_model_current, rec = this.store.process_model_record
            return { notCurrent: !!(cur && rec && rec.id && cur !== rec.id) }
        },
    },
    methods: {
        currentOf(r) { return !!(r && r._pm && r._pm.id === this.selectedId) },
        onOpen() { try { window._pmMenuForm = { opened: (window._pmMenuForm?.opened || 0) + 1, picks: window._pmMenuForm?.picks || 0 } } catch (e) { /* счётчик пробы */ } },
        run(src) {
            if (!src) return
            const action = { ...src }
            if (!action.command && !action.widget && !action.node?.value) return
            action.command = action.command || 'widget_open'
            action.widget = action.widget || action.node?.value
            let vueObj = this
            if (this.store.activeWIDGET) vueObj = this.store.activeWIDGET.vueObj
            try { window._pmMenuForm && window._pmMenuForm.picks++ } catch (e) { /* счётчик пробы */ }
            this.store.executeStoreMethod(vueObj, this.store.menuActionActiveDesk(action))   // IE 2026 10 16 / ODOO-345912: как menuNodeClicked — стол и версия активного стола
        },
        onPick(raw) {
            if (!raw || raw._pmHead || raw._pmStatus) return
            this.run(raw._src || raw)
        },
        // IE 2026 10 26 / ODOO-pending (заказ Игоря 26.10: меню процессной модели — форма меню, p054c): футер «Open the full list» закрывает форму, как выбор пункта (MenuPanel.onItem → hide); иначе форма оставалась поверх списка и забирала Esc
        onFooter(id) {
            try { this.$refs.mp && this.$refs.mp.hide && this.$refs.mp.hide() } catch (e) { /* панель уже закрыта */ }
            if (id === 'list') this.run(this.groups.list)
        },
    },
}
</script>

<style>
/* IE 2026 10 26 / ODOO-pending (заказ Игоря 26.10: меню процессной модели — форма меню): не scoped — панель телепортируется в body */
.pm-menu-btn { color: var(--text-color); font-stretch: ultra-condensed; padding: 0 4px; max-width: 200px; }
.pm-menu-btn .pm-menu-title { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.pm-menu-btn.no-current-process_model { color: #FFC107; }
/* дерево: «Date from» — правой колонкой (приписка пункта за бейджем, по правому краю) */
.pm-menu-panel .menu-panel-item.pm-row .menu-panel-badge { order: 1; }
.pm-menu-panel .menu-panel-item.pm-row .menu-panel-aside,
.pm-menu-panel .menu-panel-item.pm-colhead .menu-panel-aside { order: 2; margin-left: auto; padding-left: 10px; font-size: 12px; opacity: 1; font-variant-numeric: tabular-nums; }
.pm-menu-panel .menu-panel-item.pm-row .menu-panel-marks { order: 3; }
.pm-menu-panel .menu-panel-item.pm-colhead { margin-top: 0; padding-top: 0; padding-bottom: 3px; border-radius: 0; border-bottom: 1px solid var(--surface-border, #dee2e6);
    font-size: 11px; text-transform: uppercase; letter-spacing: .03em; color: var(--text-color-secondary, #6c757d); }
.pm-menu-panel .menu-panel-item.pm-colhead .menu-panel-aside { font-size: 11px; }
.pm-menu-panel .menu-panel-item.pm-colhead .menu-panel-ico { display: none; }
/* вид строки: значок по типу (ветка — синий, снимок — фиолетовый, тест — серый) */
.pm-menu-panel .menu-panel-item.pm-kind-branch .menu-panel-ico { color: #1f5fbf; opacity: 1; }
.pm-menu-panel .menu-panel-item.pm-kind-snapshot .menu-panel-ico { color: #6b3fb3; opacity: 1; }
/* IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: ежедневный архив ПМ): архив и папка «Archive (N)» — янтарный значок */
.pm-menu-panel .menu-panel-item.pm-kind-archive .menu-panel-ico, .pm-menu-panel .menu-panel-item.pm-archive-folder .menu-panel-ico { color: #8a5a00; opacity: 1; }
.pm-menu-panel .menu-panel-item.pm-kind-model .menu-panel-ico { color: var(--menu-panel-head); opacity: 1; }
/* открытая в этой вкладке модель — заливка акцентом (как текущая страница в панели страниц) */
.pm-menu-panel .menu-panel-item.pm-row.is-current, .pm-menu-panel .menu-panel-item.pm-row.is-current:hover { color: var(--cs-on-accent, #fff); background: var(--menu-panel-head); }
.pm-menu-panel .menu-panel-item.pm-row.is-current .menu-panel-ico, .pm-menu-panel .menu-panel-item.pm-row.is-current .menu-panel-aside { color: var(--cs-on-accent, #fff); opacity: .9; }
.pm-menu-panel .menu-panel-item.pm-row.is-current .menu-panel-text { text-decoration: none; }
.pm-menu-panel .menu-panel-item.pm-row.is-current .menu-panel-badge { background: rgba(255, 255, 255, .25); color: var(--cs-on-accent, #fff); }
.pm-menu-panel .menu-panel-item.pm-row.is-current .menu-panel-text .wj-state-match { color: #000; }
/* бейджи типа и состояния */
.pm-menu-panel .menu-panel-badge.pm-badge-current, .pm-menu-panel .menu-panel-badge.pm-badge-on { background: #e3f4e3; color: #2e7d32; }
.pm-menu-panel .menu-panel-badge.pm-badge-snapshot { background: #efe7fb; color: #6b3fb3; }
.pm-menu-panel .menu-panel-badge.pm-badge-test { background: #eceff1; color: #546e7a; }
.pm-menu-panel .menu-panel-badge.pm-badge-paused { background: #fff3cd; color: #8a6100; }
.pm-menu-panel .menu-panel-badge.pm-badge-current, .pm-menu-panel .menu-panel-badge.pm-badge-snapshot, .pm-menu-panel .menu-panel-badge.pm-badge-test,
.pm-menu-panel .menu-panel-badge.pm-badge-on, .pm-menu-panel .menu-panel-badge.pm-badge-paused { height: 16px; padding: 0 7px; border-radius: 8px; font-size: 11px; line-height: 16px; font-weight: 500; }
.pm-menu-panel .menu-panel-item.pm-status .menu-panel-ico { font-size: 8px; }
.pm-menu-panel .menu-panel-item.pm-status-on .menu-panel-ico { color: #2e7d32; opacity: 1; }
.pm-menu-panel .menu-panel-item.pm-status-paused .menu-panel-ico { color: #c98a00; opacity: 1; }
</style>
